// Currency formatting — always 2 decimal places (e.g. $20.00, $1,234.56).
// Pass a number; returns a string with USD currency symbol + thousands separators.
export function formatCurrency(amount, options = {}) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "$0.00";
  const { showSign = false } = options;
  const sign = showSign && n > 0 ? "+" : "";
  return sign + new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
}
